import React from 'react';
import { Grid, Toolbar } from '@mui/material';
import { Add } from '@mui/icons-material';
import { SearchInput } from './SearchInput';

export const EnhancedTableToolbar = props => {
  const { onSearch, openFilter } = props;

  return (
    <>
      <Grid
        container
        style={{
          padding: '25px 15px 0px 15px',
          alignItems: 'center'
        }}>
        <Grid item>
          <h3
            style={{
              fontSize: 20,
              fontFamily: 'Arial',
              paddingRight: 20,
              paddingLeft: 5
            }}>
            Partners
          </h3>
        </Grid>
        <Grid item>
          <button
            onClick={props.onAddItem}
            style={{
              border: '1px solid #0583FF',
              height: 37.5,
              borderRadius: 18.75,
              paddingLeft: 12,
              paddingRight: 12,
              backgroundColor: 'white',
              cursor: 'pointer'
            }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                color: '#0583FF'
              }}>
              <div>
                <Add />
              </div>
              <div>
                <span style={{ fontWeight: '600' }}>Add Partner</span>
              </div>
            </div>
          </button>
        </Grid>
      </Grid>
      <Toolbar
        style={{ padding: '0px 15px 15px 15px' }}
        sx={{
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 }
        }}>
        <SearchInput onSearch={onSearch} searchText={"Partners"}/>
      </Toolbar>
    </>
  );
};
